/**
 * Backend API helper.
 *
 * - Dev (localhost): calls the local Node backend (server/index.js, port 3001),
 *   which connects to the Hostinger MySQL using server/.env credentials.
 * - Production: the backend is deployed separately at
 *   https://backend.amaanativf.com (the frontend site is served from
 *   amaanativf.com), so all API calls are cross-origin by design.
 * - Override with REACT_APP_API_BASE env var if needed.
 */
const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (isLocalhost ? 'http://localhost:3001/api' : 'https://backend.amaanativf.com/api');

/**
 * GET JSON from the backend. Returns null on failure.
 */
export async function fetchJson(path) {
  try {
    const res = await fetch(`${API_BASE}/${path}`);
    if (!res.ok) return null;
    const text = await res.text();
    // If response starts with < it's HTML (404 page), not JSON
    if (text.trim().startsWith('<')) return null;
    return JSON.parse(text);
  } catch (err) {
    return null;
  }
}
